/* External */
import isEmptyL from "lodash/isEmpty";
import jwt_decode from "jwt-decode";

/* Others */
import { LANGUAGES } from "../utils";

export const USER_TYPES = {
  ALGAR_OTT: "algar-ott",
  B2B2C: "mso-dth",
  IPLAN: "iplan-ott",
  LATAM_OTT: "latam-ott",
  NEOTV_OTT: "neotv-ott",
  OTT: "ott",
  SKY_B2B2C: "sky-dth",
  TVE: "tve"
};

export const FORGEROCK_ACCOUNT_TYPES = {
  SSLA_OTT: "SSLA-OTT",
  SSLA_TVE: "SSLA-DTH",
  BR_OTT: "BR-OTT",
  BR_TVE: "BR-DTH",
  B2B2C: "MSO-DTH",
  SKY_B2B2C: "SKY-DTH"
};

export const FORGE_ROCK_LOGIN_SCOPE = "openid profile entitlements";

export const MSO_PROVIDERS = {
  ALGAR: "algar",
  ETB: "etb",
  IPLAN: "iplan",
  NEOTV: "neotv",
  SKY: "sky"
};

/**
 * @method getUserTypeByBusinessUnit
 * @description Returns the user type based on the business unit
 * @param {string} businessUnit
 * @param {string} msoProvider
 */
export function getUserTypeByBusinessUnit(businessUnit, msoProvider = "") {
  const msoProviderTrimmed = msoProvider.trim();
  let userType;
  switch (businessUnit) {
    case FORGEROCK_ACCOUNT_TYPES.SSLA_OTT:
    case FORGEROCK_ACCOUNT_TYPES.BR_OTT:
      userType = USER_TYPES.OTT;
      break;
    case FORGEROCK_ACCOUNT_TYPES.SSLA_TVE:
    case FORGEROCK_ACCOUNT_TYPES.BR_TVE:
      userType = USER_TYPES.TVE;
      break;
    case FORGEROCK_ACCOUNT_TYPES.B2B2C:
      switch (msoProviderTrimmed) {
        case MSO_PROVIDERS.ALGAR:
          userType = USER_TYPES.ALGAR_OTT;
          break;
        case MSO_PROVIDERS.IPLAN:
          userType = USER_TYPES.IPLAN;
          break;
        case MSO_PROVIDERS.NEOTV:
          userType = USER_TYPES.NEOTV_OTT;
          break;
        default:
          userType = USER_TYPES.B2B2C;
      }
      break;
    case FORGEROCK_ACCOUNT_TYPES.SKY_B2B2C:
      userType = USER_TYPES.SKY_B2B2C;
      break;
    default:
      userType = USER_TYPES.OTT;
  }
  return userType;
}

export function getUserLanguages(user = {}) {
  let { account: { profile: { customData: { preferences: { language } = {} } = {} } = {} } = {} } = user;

  if (isEmptyL(language)) {
    language = {
      client: LANGUAGES.SPANISH_LANGUAGE,
      audio: null,
      subtitles: null
    };
  } else {
    const { client } = language;

    if (!client) {
      language = {
        ...language,
        client: LANGUAGES.SPANISH_LANGUAGE
      };
    }
  }

  return language;
}

export function getTokenDecoded(token) {
  const idToken = localStorage.getItem(token) || "";
  return jwt_decode(idToken);
}

/**
 * @method isUserLoggedIn
 * @description Method that validate if the user object has values of a user active.
 *
 */
export function isUserLoggedIn(user) {
  const { deviceId, sessionToken } = user;
  return !!(deviceId && sessionToken);
}
